import { Box, styled } from '@zenchef/styled-system/jsx'
import { HTMLStyledProps } from '@zenchef/styled-system/types'

import getTestId from '@/utils/getTestId'

// props of radio input
interface RadioProps extends TestingAttributes, HTMLStyledProps<'input'> {
  error?: boolean
}

const Radio = ({ testId, name, value, checked, error, ...props }: RadioProps) => {
  return (
    <Box position='relative' margin='5px 0 0 0' display='inline-block' {...props}>
      <styled.input
        type='radio'
        display='none'
        name={name}
        value={value}
        checked={checked}
        data-testid={getTestId(testId, 'radio')}
        {...props}
      />
      <Box
        cursor='pointer'
        pr='5px'
        width='14px'
        height='14px'
        borderRadius='10px'
        backgroundColor={checked ? 'restaurant' : '#ffffff'}
        borderWidth='m'
        borderStyle='solid'
        borderColor={error ? 'red.500' : checked ? 'background.brand.adaptive' : 'charcoal.200'}
        _after={{
          content: '""',
          position: 'absolute',
          borderRadius: '10px',
          margin: '1px',
          bgColor: {
            _highContrast: 'white',
            _lowContrast: 'background.brand.low-contrast'
          },
          width: checked ? '6px' : 'unset',
          height: checked ? '6px' : 'unset',
          top: checked ? '3px' : 'unset',
          left: checked ? '3px' : 'unset'
        }}
      />
    </Box>
  )
}

Radio.defaultProps = {
  width: '20px',
  height: '20px'
}

export default Radio
